import { useGetTheme } from '@pba/react-theme';
import { Avatar as AvatarA } from 'antd';
import cn from 'classnames';
import type { ComponentProps } from 'react';
import { type AvatarSize, useResolveAvatarSize } from '../hooks';
import styles from './avatar-group.module.css';
import { AvatarGroupSizeProvider } from './AvatarGroupSizeContext';

export type AvatarGroupProperties = { size?: AvatarSize | number } & Omit<ComponentProps<typeof AvatarA.Group>, 'size'>;

const AvatarGroup = ({ className, size = 'md', ...rest }: AvatarGroupProperties) => {
  const {
    reactComponents: {
      avatar: {
        size: {
          sm: { value: smallAvatarGroupMaxSize },
        },
      },
    },
  } = useGetTheme();
  const resolveAvatarSize = useResolveAvatarSize();
  const groupSizeInPixels = resolveAvatarSize({ value: size });

  return (
    <AvatarGroupSizeProvider value={size}>
      <AvatarA.Group
        className={cn(
          styles.group,
          {
            [styles['group--small'] ?? '']: groupSizeInPixels <= smallAvatarGroupMaxSize,
          },
          className,
        )}
        size={groupSizeInPixels}
        {...rest}
      />
    </AvatarGroupSizeProvider>
  );
};

export default AvatarGroup;
